import { useEffect, useState } from 'react';
import type { RefObject } from 'react';
import type { CameraSettings, ColorSample } from '../../types';
import { sampleVideoPalette } from './colorAnalysis';

export function useColorAnalysis(videoRef: RefObject<HTMLVideoElement | null>, settings: CameraSettings, enabled: boolean) {
  const [palette, setPalette] = useState<ColorSample[]>([]);

  useEffect(() => {
    if (!enabled) return;
    const update = () => {
      const video = videoRef.current;
      if (video) setPalette(sampleVideoPalette(video, settings.colorSampling === 'region' ? settings.roi : undefined));
    };
    update();
    const timer = window.setInterval(update, 450);
    return () => window.clearInterval(timer);
  }, [enabled, settings.colorSampling, settings.roi, videoRef]);

  return palette;
}
